import Vue from 'vue'
import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields';
import axios from 'axios';
const CancelToken = axios.CancelToken;
let cancelObjects = [];

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  	promocode: '',
	promocodeAmount: 0,
  	buttonIsDisabled:true,
  	totalCost:0,
  	sportList:[],
  	sportTariffs:{},
  	popupIsActive:false,
  	maxCategory:1,
  	selectedSports:[],
  	isLoading:false,
  	term:{
  		name:'1 месяц',
  		value:'MONTH_1'
  	},
  	count:{
  		name:'1 человека',
  		value:1
  	},
  	sum:{
  		name:'50 000 ₽',
  		value:50000
  	},
  	termOptions: [{
  		name:'1 день',
  		value:'DAY_1'
  	},
  	{
  		name:'1 месяц',
  		value:'MONTH_1'
  	},
	  {
		name:'3 месяца',
		value:'MONTH_3'
	},
	{
		name:'6 месяцев',
		value:'MONTH_6'
	},

  	{
  		name:'12 месяцев',
  		value:'MONTH_12'
  	}],
  	countOptions: [{
  		name:'1 человека',
  		value:1
  	},
  	{
  		name:'2-х человек',
  		value:2
  	},
  	{
  		name:'3-х человек',
  		value:3
  	},
  	{
  		name:'4-х человек',
  		value:4
  	},
  	{
  		name:'5-ти человек',
  		value:5
  	},
  	{
  		name:'6-ти человек',
  		value:6
  	},
  	{
  		name:'7-ми человек',
  		value:7
  	},
  	{
  		name:'8-ми человек',
  		value:8
  	},
  	{
  		name:'9-ти человек',
  		value:9
  	},
  	{
  		name:'10-ти человек',
  		value:10
  	},
  	{
  		name:'11-ти человек',
  		value:11
  	},
  	{
  		name:'12-ти человек',
  		value:12
  	},
  	{
  		name:'13-ти человек',
  		value:13
  	},
  	{
  		name:'14-ти человек',
  		value:14
  	},
  	{
  		name:'15-ти человек',
  		value:15
  	},
  	{
  		name:'16-ти человек',
  		value:16
  	},
  	{
  		name:'17-ти человек',
  		value:17
  	},
  	{
  		name:'18-ти человек',
  		value:18
  	},
  	{
  		name:'19-ти человек',
  		value:19
  	},
  	{
  		name:'20-ти человек',
  		value:20
  	},
  	{
  		name:'21-го человека',
  		value:21
  	},
  	{
  		name:'22-х человек',
  		value:22
  	},
  	{
  		name:'23-х человек',
  		value:23
  	},
  	{
  		name:'24-х человек',
  		value:24
  	},
  	{
  		name:'25-ти человек',
  		value:25
  	},
  	{
  		name:'26-ти человек',
  		value:26
  	},
  	{
  		name:'27-ми человек',
  		value:27
  	},
  	{
  		name:'28-ми человек',
  		value:28
  	},
  	{
  		name:'29-ти человек',
  		value:29
  	},
  	{
  		name:'30-ти человек',
  		value:30
  	}],
  	sumOptions: [{
  		name:'50 000 ₽',
  		value:50000
  	},
  	{
  		name:'100 000 ₽',
  		value:100000
  	},
	  {
		name:'300 000 ₽',
		value:300000
	},
	{
		name:'500 000 ₽',
		value:500000
	},

  ],
  	insurerName: '',
    insurerGender: '',
  	birthDate: '',
  	passport: '',
	sportClubName: '',
  	address: '',
  	phone: '',
  	mail: '',
  	polisDate: '',
  	insuredPeople:[
  		{
  			FIO:'',
	  		BIRTHDAY:'',
        SEX:'',
        id:0
  		}
  	],
  	Schema:{
		sportClubName: {
			placeholder: 'Название спортивного клуба (при наличии)',
			name: 'sportClubName',
			mask: '',
			validateRules: {
			  required: false,
			}
		  },
		promocode:{
			placeholder:'промокод',
			name:'promocode',
			mask:'',
			validateRules:{}
		},
  		mail:{
				placeholder:'Электронная почта',
				name:'mail',
				mask:'',
				validateRules:{
					required: true,
          email: true
				}
			},
			polisDate:{
				placeholder:'Когда нужен полис?',
				name:'polisDate',
				mask: '99.99.9999',
				validateRules:{
					required: true,
					date_format: 'dd.MM.yyyy',
					notPast:true,
					dayMax60: true
				}
			},
  		phone:{
				placeholder:'Телефон',
				name:'phone',
				mask: '+7 (999) 999 99 99',
				validateRules:{
					required: true,
					regex: /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/
				}
			},
			sports:{
				placeholder:'Каким спортом занимаетесь?',
				name:'sports',
				setter:'sports',
				mask:'',
				hasPopup:true,
				hasDescription:true,
				validateRules:{
					required:true,
					// alpha:true
				}
			},
			term:{
				placeholder:'Страховка на срок',
				name:'term',
				setter:'term',
				mask:'',
				start:1,
				validateRules:{
					// required:true,
					// alpha:true
				}
			},
			count:{
				placeholder:'Страховка для',
				name:'count',
				setter:'count',
				mask:'',
				start:0,
				validateRules:{
					// required:true,
					// alpha:true
				}
			},
			sum:{
				placeholder:'Страховая сумма на одного',
				name:'sum',
				setter:'sum',
				mask:'',
				start:0,
				validateRules:{
					// required:true,
					// alpha:true
				}
			},
			insurerName:{
				placeholder:'Фамилия Имя Отчество',
				name:'insurerName',
				getter:'getInsurerName',
				setter:'insurerName',
				mask:'',
				validateRules:{
					required:true
				}
			},
			birthDate:{
				placeholder:'Дата рождения',
				name:'birthDate',
				getter:'getBirthDate',
				setter:'birthDate',
				mask:'99.99.9999',
				validateRules:{
					required:true,
					date_format: 'dd.MM.yyyy',
          yearsMin18: true,
          yearsMax65: true,
				}
			},
			passport:{
				placeholder:'Номер паспорта',
				name:'passport',
				mask:'9999 999999',
				validateRules:{
					regex:/\d{4}.{1}\d{6}/,
					required:true,

					// length:10,
					// numeric:true
				}
			},
			address:{
				placeholder:'Адрес регистрации',
				name:'address',
				getter:'getAddress',
				setter:'address',
				mask:'',
				validateRules:{
					required:true,
				}
			},
			insuredPeopleName:{
				placeholder:'Фамилия Имя Отчество',
				name:'insuredPeople',
				mask:'',
				validateRules:{
					required:true,
				}
			},
			insuredPeopleBirthDate:{
				placeholder:'Дата рождения',
				name:'birthDate',
				mask:'99.99.9999',
				validateRules:{
					required:true,
					date_format: 'dd.MM.yyyy',
          yearsMin3: true,
          yearsMax55: true,
				}
			},
  	},
	  pampaduClickId: '',
	  pampaduSubId: '',
	  salesChannel: '',
	  mentor: '',
	  agent: '',
  },
  getters:{
	getSportClubName(state) {
		return state.sportClubName;
	  },
  	getIsLoading(state) {
  		return state.isLoading;
  	},
  	getPolisDate(state) {
  		return state.polisDate;
  	},
  	getButtonIsDisabled(state) {
  		return state.buttonIsDisabled;
  	},
  	getSelectedSports(state) {
  		return state.selectedSports;
  	},
  	getMail(state) {
  		return state.mail;
  	},
  	getPhone(state) {
  		return state.phone;
  	},
  	getSum(state) {
  		return state.sum;
  	},
  	getMaxCategory(state) {
  		return state.maxCategory;
  	},
  	getTotalCost(state) {
  		return state.totalCost;
  	},
  	// getFirstTerm(state) {
  	// 	return state.term[0];
  	// },
  	getSelectedSports(state) {
  		return state.selectedSports;
  	},
  	getTerm(state) {
  		return state.term;
  	},
  	getPopupIsActive(state) {
  		return state.popupIsActive;
  	},
  	getSchema(state) {
  		return state.Schema;
  	},
  	getCount(state) {
  		return state.count;
  	},
    getInsurerGender(state) {
      return state.insurerGender;
    },
  	getInsurerName(state) {
  		return state.insurerName;
  	},
  	getBirthDate(state) {
  		return state.birthDate;
  	},
  	getPassport(state) {
  		return state.passport;
  	},
  	getAddress(state) {
  		return state.address;
  	},
  	getInsuredPeople(state) {
  		return state.insuredPeople;
  	},
  	getSportList(state){
  		return state.sportList;
  	},
  	getSportTariffs(state){
  		return state.sportTariffs;
  	},
  	getSum(state){
  		return state.sum;
  	},
	  getPampaduClickId(state) {
		  return state.pampaduClickId;
	  },
	  getPampaduSubId(state) {
		  return state.pampaduSubId;
	  },
	  getSalesChannel(state) {
		  return state.salesChannel;
	  },
	  getMentor(state) {
		  return state.mentor;
	  },
	  getAgent(state) {
		  return state.agent;
	  },
  	getField
  },
  mutations: {
  	updateField,
	setSportClubName(state, payload) {
		state.sportClubName = payload;
	},
  	setIsLoading(state, payload){
  		state.isLoading = payload;
  	},
  	setButtonIsDisabled(state, payload){
  		state.buttonIsDisabled = payload;
  	},
  	setMaxCategory(state, payload){
  		state.maxCategory = payload;
  	},
  	setSelectedSports(state, payload){
  		state.selectedSports = payload;
  	},
  	setPopupIsActive(state, payload){
  		state.popupIsActive = payload;
  	},
  	setInsurerName(state, payload){
  		state.insurerName = payload;
  	},
  	setTerm(state, payload){
  		state.term = payload;
  	},
  	setCount(state, payload){
  		state.count = payload;
  	},
  	setSum(state, payload){
  		state.sum = payload;
  	},
  	setBirthDate(state, payload){
  		state.birthDate = payload;
  	},
  	setPassport(state, payload){
  		state.passport = payload;
  	},
  	setAddress(state, payload){
  		state.address = payload;
  	},
  	setInsuredPeople(state, payload){
  		state.insuredPeople = payload;
  	},
  	setSportList(state, payload){
  		state.sportList = payload;
  	},
  	setSportTariffs(state, payload){
  		state.sportTariffs = payload;
  	},
  	setTotalCost(state, payload){
  		state.totalCost = payload;
  	},
    setPromocodeAmount(state, payload) {
  		state.promocodeAmount = payload;
	},
	  setPampaduClickId(state, payload) {
		  state.pampaduClickId = payload;
	  },
	  setPampaduSubId(state, payload) {
		  state.pampaduSubId = payload;
	  },
	  setSalesChannel(state, payload) {
		  state.salesChannel = payload;
	  },
	  setMentor(state, payload) {
		  state.mentor = payload;
	  },
	  setAgent(state, payload) {
		  state.agent = payload;
	  },
  },
  actions: {
	  checkPromocode({getters, commit, dispatch, state}) {
		  let cancel = {name: 'checkPromocode'}
		  const {promocode} = state

		  // Если первый раз вызвана апишка с cancel
		  let idx = -1
		  let cancelToken = null
		  if (cancel.name) {
			  idx = cancelObjects.findIndex(item => item.name === cancel.name)
			  if (idx === -1) {
				  let source = CancelToken.source()
				  cancelObjects.push({name: cancel.name, source})
				  cancelToken = source.token
			  }
		  }

		  // Если функция с cancel вызвана несколько раз, отменяем axios, задаем новый токен
		  let index = cancelObjects.findIndex(item => item.name === cancel.name)
		  if (index !== -1 && idx !== -1) {
			  if (cancelObjects[index].source) {
				  cancelObjects[index].source.cancel('Cancelled')
				  let source = CancelToken.source()
				  cancelObjects[index].source = source
				  cancelToken = source.token
			  }
		  }

		  const settings = {
			  type:'widget_ns_sport',
			  method_calc: "checkDiscount",
			  promocode,
			  cancelToken
		  }
		  // axios.post('https://zetta-6.air-dev.agency/.ajax/order.php', settings, {
		  axios.post('/.ajax/order.php', settings, {
			  headers:{
				  'X-Requested-With': 'XMLHttpRequest'
			  }
		  })
			  .then((response) => {
				  if(response.status == 200) {
					  return response;
				  }
				  throw new Error('Network response was not ok');
			  })
			  .then((json) => {
				  // cancelToken.reason будет только если отменен запрос
				  if(cancelToken.reason)
					  throw('')

				  // удаляем токен
				  if (cancelToken)
					  cancelObjects.splice(index, 1)

				  if(json.data.result) {
					  commit('setPromocodeAmount', json.data.result);
					  // commit('updateField', {path: 'promocode', value: promocode})
					  // commit('updateField', {path: 'promocodeAmount', value: json.data})
				  } else {
					  commit('setPromocodeAmount', 0);
					  // commit('updateField', {path: 'promocode', value: ''})
					  // commit('updateField', {path: 'promocodeAmount', value: ''})
				  }
			  })
			  .catch((error) => {
				  if (error)
					  console.log(error);
			  });
	  },
  	sendData({getters, commit, dispatch, state}) {
  		const {
			getSportClubName,
  			getInsurerName,
  			getPassport,
  			getBirthDate,
  			getAddress,
  			getMail,
  			getPhone,
  			getInsuredPeople,
  			getTotalCost,
        	getInsurerGender,
			getPampaduClickId,
			getPampaduSubId,
			getSalesChannel,
			getMentor,
			getAgent,
  		} = getters;

  		const insured = [...getters.getInsuredPeople];
  		const insurance_period = getters.getTerm.value;
  		const insurance_sum = getters.getSum.value;
  		const sport = [...getters.getSelectedSports.map(item => item.UF_NAME)];
      const category = [...getters.getSelectedSports.map(item => +item.UF_CATEGORY)];
  		const settings = {
  			type:'widget_ns_sport',
  			send: 'y',
			sportClubName: getSportClubName,
			start_date:state.polisDate,
			promocode:state.promocode,
  			insurer: {
  				FIO:getInsurerName,
  				BIRTHDAY:getBirthDate,
  				PASSPORT:getPassport,
  				ADDRESS:getAddress,
  				EMAIL:getMail,
  				PHONE:getPhone,
          SEX:getInsurerGender
  			},
        category,
  			insured,
  			insurance_period,
  			insurance_sum,
  			sport,
  			summ_back:getTotalCost,
			pampadu_click_id: getPampaduClickId,
			pampadu_sub_id: getPampaduSubId,
			saleChannelIsn: getSalesChannel,
			curatorIsn: getMentor,
			agentIsn: getAgent,
	  	}
	  	commit('setIsLoading', true);
  		axios.post('/.ajax/order.php', settings, {
				headers:{
					'X-Requested-With': 'XMLHttpRequest'
				}
			})
			.then((response) => {
				if(response.status == 200) {
						return response;
				}
				throw new Error('Network response was not ok');
			})
			.then((json) => {
				if(json.data.redirect) {
					window.location.href = json.data.redirect;
					// console.log(json.data)
				}
				commit('setIsLoading', false);
			})
			.catch((error) => {
					console.log(error);
			});
  	},
  	getData({getters, commit, dispatch}){
  		const settings = {
  			action:'getData'
	  	}
  		axios.post('/widget/ns-sport/ajax.php', settings, {
				headers:{
					'X-Requested-With': 'XMLHttpRequest'
				}
			})
			.then((response) => {
				if(response.status == 200) {
						return response;
				}
				throw new Error('Network response was not ok');
			})
			.then((json) => {
					commit('setSportList', json.data.CalcNsSportActivitiesList)
					commit('setSportTariffs', json.data.CalcNsSportTariffs)
			})
			.catch((error) => {
					console.log(error);
			});
  	},
  	sports({commit}, payload){
  		commit('setSelectedSports', payload);
  	},
  	maxCategory({commit, getters}, payload){
  		let category = 1;
      selectedSports.forEach((el) => {
        if(parseInt(el.UF_CATEGORY) > category) {
          category = parseInt(el.UF_CATEGORY);
        }
      })
  		commit('setMaxCategory', payload);
  	},
  	insurerName({commit}, payload){
  		commit('setInsurerName', payload);
  	},
  	term({commit}, payload){
  		commit('setTerm', payload);
  	},
  	sum({commit}, payload){
  		commit('setSum', payload);
  	},
  	count({commit}, payload){
  		commit('setCount', payload);
  	},
  	birthDate({commit}, payload){
  		commit('setBirthDate', payload);
  	},
  	passport({commit}, payload){
  		commit('setPassport', payload);
  	},
  	address({commit}, payload){
  		commit('setAddress', payload);
  	},
  	setInsuredPeopleCount({getters, commit, dispatch}){
  		let count = getters.getCount.value;
  		let insuredPeople = []
  		for(let i = 0; i < count; i++) {
	  		insuredPeople[i] = {
	  			FIO:'',
	  			BIRTHDAY:'',
          SEX:''
	  		}
	  	}
  		commit('setInsuredPeople', insuredPeople);
  	},

  }
})
